import React, { useEffect, useRef, useState } from "react";
import { Container, Col, Card, CardBody } from "reactstrap";
import { addEmployerGroup } from "../../slices/broker/thunk";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "../../slices/auth/hooks";
import Loading from "../../Components/Loading";
import EmployerGroupsTable from "../../Components/Tables/EmployerGroupTable/EmployerGroupTable";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import Swal from "sweetalert2";
import { DASHBOARD_USER_ROLES } from "../../constants";
import { getRolesForTables } from "../../slices/admin/thunk";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import employersIcon from "../../assets/images/iconsRoles/employerGroupIcon.svg";

const DashboardEmployerGroups = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();

  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [modalAddEmployerGroups, setModalAddEmployerGroups] = useState(false);

  const [employers, setEmployers] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const [totalEmployers, setTotalEmployers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleToggleModal = () => {
    setModalAddEmployerGroups(!modalAddEmployerGroups);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchEmployeesBroker = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: DASHBOARD_USER_ROLES.BROKER,
          role: "employers",
          status: "active",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchEmployeesBroker();
  }, [currentPage, debouncedSearchTerm, dispatch, currentUser.id]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleCreateEmployerGroup = async (values) => {
    try {
      setLoadingCreate(true);
      await dispatch(addEmployerGroup(values)).unwrap();

      Swal.fire({
        title: "Success!",
        text: "Employer group added successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setModalAddEmployerGroups(false);

      setLoadingCreate(false);
      fetchEmployeesBroker();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text:
          error.message || "An error occurred while adding the employer group",
        icon: "error",
        confirmButtonText: "OK",
      });
      setModalAddEmployerGroups(true);

      setLoadingCreate(false);
    }
  };

  const employerLabel = (
    <label htmlFor="like-input" className="form-label fw-semibold fs-6">
      <span className="fs-15 text-muted fw-normal">
        My Broker Code: {currentUser.inviteCode}
      </span>
    </label>
  );

  return (
    <React.Fragment>
      {/* <Modal */}
      {modalAddEmployerGroups && (
        <AddRoleModal
          open={modalAddEmployerGroups}
          setOpen={setModalAddEmployerGroups}
          onCreate={handleCreateEmployerGroup}
          roleToAdd="Employer Group"
          loading={loadingCreate}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Employer Groups"}
            icon={employersIcon}
            svg={true}
            text={employerLabel}
          />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                  />
                </div>
                <ButtonAddRole
                  open={handleToggleModal}
                  roleToAdd="Employer Group"
                />
              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployerGroupsTable
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        data={employers}
                        paginationProps={{
                          itemsCount: employers.length,
                          totalPages: totalPages,
                          totalItems: totalEmployers,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardEmployerGroups;
